import { API_ENDPOINTS } from '../constants/api';
import apiClient from '../config/axiosInterceptors';
import { ResponseHandler } from '../config/responseHandler';

class PromotionService {
  /**
   * Fetch promotion data for a user
   * @param {string} userId - User ID to fetch promotion data for
   * @returns {Promise<Object>} Promotion data response
   */
  async getPromotion(userId) {
    try {
      const response = await apiClient.get(`${API_ENDPOINTS.GET_PROMOTION}/${userId}`);
      return ResponseHandler.handleSuccess(response, 'Promotion data fetched successfully');
    } catch (error) {
      throw ResponseHandler.handleError(error, 'Failed to fetch promotion data');
    }
  }

  /**
   * Create a new promotion
   * @param {Object} promotionData - Promotion data to create
   * @returns {Promise<Object>} Created promotion response
   */
  async createPromotion(promotionData) {
    try {
      const response = await apiClient.post(API_ENDPOINTS.CREATE_PROMOTION, promotionData);
      return ResponseHandler.handleSuccess(response, 'Promotion created successfully');
    } catch (error) {
      throw ResponseHandler.handleError(error, 'Failed to create promotion');
    }
  }

  /**
   * Cancel an active promotion
   * @param {string} promotionId - Promotion ID to cancel
   * @returns {Promise<Object>} Cancel promotion response
   */
  async cancelPromotion(promotionId) {
    try {
      const response = await apiClient.put(`${API_ENDPOINTS.CANCEL_PROMOTION}/${promotionId}/cancel`);
      return ResponseHandler.handleSuccess(response, 'Promotion cancelled successfully');
    } catch (error) {
      throw ResponseHandler.handleError(error, 'Failed to cancel promotion');
    }
  }

  /**
   * Check promotion data for a creator
   * @param {string} creatorId - Creator ID to check promotion data for
   * @returns {Promise<Object>} Promotion check response
   */
  async checkPromotion(creatorId) {
    try {
      const response = await apiClient.get(`${API_ENDPOINTS.GET_PROMOTION}/${creatorId}/check`);
      return ResponseHandler.handleSuccess(response, 'Promotion check completed successfully');
    } catch (error) {
      throw ResponseHandler.handleError(error, 'Failed to check promotion');
    }
  }

}

export default new PromotionService();

